export const RENDERER_CLEAR_COLOR = 0xcccccc;
export const TOLERANCE = 0.0001;